export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const SET_CUSTOMERS_DATA_LOADING = "SET_CUSTOMERS_DATA_LOADING";
export const SET_SEARCH_CUSTOMERS = "SET_SEARCH_CUSTOMERS";
export const SET_SEARCH_CUSTOMER_BY_ID = "SET_SEARCH_CUSTOMER_BY_ID";